var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"ml-2 mt-0",attrs:{"inset":"","dense":"","hide-details":"auto","label":_vm.item.label,"disabled":_vm.disabled || _vm.item.readonly},on:{"change":_vm.onChange},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }